import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import upsellImage from '~/assets/images/upsell/tracking-upsell.png'
import AccountApprovalRequired from '~/Common-Objects/Account/AccountApprovalRequired'

import * as styles from './upsell.module.scss'

export default function TrackingUpsell() {
    const history = useHistory()
    return (
        <Paper className={styles.root}>
            <div className={styles.upsellContainer}>
                <img src={upsellImage} className={styles.upsellImage} />
                <div className={styles.upsellText}>
                    <div className={styles.upsellIcon}>
                        <Icons icon='globe' />
                    </div>
                    <div className={styles.upsellTitle}>Make every visit count</div>
                    <div className={styles.upsellDescription}>
                        Start tracking what your contacts do after they click on your campaigns. With just one line of
                        code, you’ll unlock powerful insights into visitor behaviour – opening the door to smarter, more
                        effective marketing.
                    </div>

                    <div className={styles.upsellActions}>
                        <AccountApprovalRequired
                            messageOrientation='right'
                            notApprovedText={'Approval is required to enable Site Tracking'}
                            inReviewText={'Your account is under review'}
                            activateFrom={'tracking'}
                            inReviewAction={
                                <div className='quickFlex' style={{ alignItems: 'center', gap: 16 }}>
                                    <Button
                                        className='button-primary'
                                        iconLeft={<Icons icon='upgradeChevrons' />}
                                        onClick={() => history.push('/cp/company/subscription')}
                                    >
                                        Upgrade
                                    </Button>
                                </div>
                            }
                            approvedAction={
                                <div className='quickFlex' style={{ alignItems: 'center', gap: 16 }}>
                                    <Button
                                        className='button-primary'
                                        iconLeft={<Icons icon='upgradeChevrons' />}
                                        onClick={() => history.push('/cp/company/subscription')}
                                    >
                                        Upgrade
                                    </Button>
                                    <a
                                        className='quickFlex'
                                        style={{ alignItems: 'center', gap: 2 }}
                                        target='_blank'
                                        href='https://transpond.io/support/growing-your-audience/website-tracking'
                                    >
                                        Learn more
                                        <Icons icon='external' style={{ width: '20px', height: '20px' }} />
                                    </a>
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
        </Paper>
    )
}
